import React from 'react'

const Principles = ({ align }) => {

  const classVal = align ? 'pt-5' : 'pt-5 text-center'
  return (
    <div className={classVal} >

      <h2 className="Heading" >Our Principles</h2>
      <hr className='horLine' />
      <p className='lead' >
        We sell world-class products manufactured by world-class manufacturers to ensure the perfect blend of renowned products, guaranteed quality and supreme solutions
      </p>


    </div>
  )
}

export default Principles